import { useState, useEffect, useContext } from "react";
import { useRouter } from "next/router";

// component
import SearchCatalogue from "@/components/catalogue/SearchCatalogue";
import SEO from "@/components/seo/SEO";

// API
import { API, graphqlOperation } from "aws-amplify";
import {
  listItemsByCollection,
  customerSearchProducts,
} from "@/graphql/queries";

// hooks
import { generateAdwordPayload } from "@/hooks/useAnaytics";

// utils
import { isEmpty, totalPagination } from "@/utils/util.js";
import _ from "lodash";
import Cookies from "universal-cookie";

// contexts
import MerchantContext from "@/contexts/MerchantContext";

function SearchCatalogueScreen(props) {
  const merchantInfoContext = useContext(MerchantContext);

  const cookie = new Cookies();
  const [totalItem, setTotalItem] = useState("");
  const router = useRouter();
  const INIT_NEXT_TOKEN = 0;
  const [total, setTotal] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState("");
  const sortField = {
    field: "updatedAt",
    direction: "desc",
  };
  const [itemListing, setItemListing] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [searchFilter, setSearchFilter] = useState();
  const LIMIT = 20;
  const TOTAL_PAGES = totalPagination(total, LIMIT);

  let tempProductList = [];
  let tempProductURL = [];

  // Get Total Product
  const getProductList = async (
    nextToken = INIT_NEXT_TOKEN,
    searchKeyword = ""
  ) => {
    setIsLoading(true);
    let seoUrl = "collection/recommended-for-you";
    try {
      let result = null;
      let tmpList = [];

      const searchFilterObj = {
        itemTitle: { matchPhrasePrefix: searchKeyword },
        salesChannelName: { eq: "Online Store" },
        isDisabled: { eq: false },
      };

      const searchParams = searchKeyword
        ? searchFilterObj
        : _.omit(searchFilterObj, ["itemTitle"]);

      let params = {
        limit: LIMIT,
        nextToken: nextToken,
        sort: sortField,
        filter: {
          and: {
            merchantId: { eq: merchantInfoContext.merchantId },
            ...searchParams,
          },
        },
        merchantId: merchantInfoContext.merchantId,
      };
      const { data } = await API.graphql(
        graphqlOperation(customerSearchProducts, params)
      );

      if (data.customerSearchProducts.status === "true") {
        tmpList = data.customerSearchProducts.items;
      }
      setItemListing(tmpList);
      setTotal(data.customerSearchProducts.total ?? 0);
      setIsLoading(false);
      setIsPageLoading(false);
    } catch (error) {
      setIsLoading(false);
      setIsPageLoading(false);
    }
  };

  useEffect(() => {
    // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    const page = router.query.page ? parseInt(router.query.page) : 1;
    const searchKeyword = router.query.keyword ?? "";

    console.log({ page, searchKeyword });
    setSelectedPage(page);
    setSearchKeyword(searchKeyword);
    getProductList((page - 1) * LIMIT, searchKeyword);
    generateAdwordPayload("/products", "", merchantInfoContext.merchantId);
  }, [router.query]);

  return (
    <>
      <SEO title="Search" keywords="" description="Search for items" />
      <SearchCatalogue
        itemListing={itemListing}
        getProductList={getProductList}
        isPageLoading={isPageLoading}
        isLoading={isLoading}
        total={total}
        totalPages={TOTAL_PAGES}
        nextToken={INIT_NEXT_TOKEN}
        limit={LIMIT}
        selectedPage={selectedPage}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
      />
    </>
  );
}

export default SearchCatalogueScreen;
